import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagarcabs() {



  const cardData =
  {
    keyword: 'Pune to Sambhajinagar Cab',
    heading: 'Sai Trupti Cabs: Pune to Sambhajinagar Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Sambhajinagar (Chhatrapati Sambhaji Nagar) cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Sambhajinagar. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24 × 7 customer support, Sai Trupti Cabs makes your travel from Pune to Sambhajinagar convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Sambhajinagar with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, stand as a timeless masterpiece of India’s Buddhist art and spirituality. Carved between the 2nd century BCE and 6th century CE, these 30 rock-cut caves depict the life of the Buddha through exquisite frescoes and sculptures. The murals still glow with ancient pigments, narrating stories of compassion and enlightenment. Hidden in the Sahyadri hills and rediscovered in 1819, Ajanta feels like a sacred gallery frozen in time. As sunlight streams through the arches, the paintings shimmer with life. Visiting Ajanta is a journey into the soul of India’s artistic and spiritual heritage."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO-listed marvel, embody India’s rare unity of faith. Here, Hindu, Buddhist, and Jain temples coexist in perfect harmony — 34 magnificent rock-cut caves carved between the 6th and 10th centuries. The crown jewel, the Kailasa Temple, is an engineering wonder sculpted from a single rock to resemble Mount Kailash. Intricate carvings, colossal pillars, and celestial sculptures adorn every surface. The caves echo chants of devotion and centuries of artistry. Walking through Ellora feels like traversing time itself — from mythology to divinity — a living testament to Sambhajinagar’s glorious legacy."
  },
  {
    "title": "Bibi ka Maqbara",
    "description": "Often called the 'Taj Mahal of the Deccan', Bibi ka Maqbara was built by Prince Azam Shah in 1678 as a tribute to his mother, Dilras Banu Begum. The white marble mausoleum rises gracefully against the backdrop of the Aurangabad hills, surrounded by Mughal-style gardens and fountains. Its symmetry, carvings, and domes mirror the grandeur of Agra’s Taj Mahal yet possess a charm uniquely Deccani. As evening falls, the monument glows in soft moonlight, creating a dreamlike aura. Bibi ka Maqbara symbolizes love, artistry, and royal devotion — the poetic heart of Sambhajinagar."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Perched atop a conical hill, Daulatabad Fort is one of India’s strongest hill forts and a marvel of medieval defense engineering. Originally known as Devagiri, it was briefly the capital of India under Muhammad bin Tughlaq. The fort’s triple-layered walls, dark passageways, and unique moat system guarded by crocodiles once made it impregnable. Climbing to the top offers breathtaking views of the countryside and glimpses of cannons that once thundered in battle. The fort’s architectural brilliance and haunting history make it a thrilling stop for trekkers and history lovers exploring Sambhajinagar."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Located just a kilometer from the Ellora Caves, Grishneshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva. Built in red stone with intricate carvings and tall spires, it radiates divine energy and spiritual serenity. The temple’s architecture blends Hemadpanthi and Maratha styles, featuring detailed sculptures of gods and mythological scenes. Devotees gather for Abhishek rituals amid rhythmic chants and incense fragrance. The sanctum’s tranquil atmosphere instills peace and reverence. Visiting Grishneshwar completes the sacred circle of Shiva devotion, making it a spiritual highlight of Sambhajinagar."
  },
  {
    "title": "Panchakki (Water Mill)",
    "description": "Panchakki, or the Water Mill, is a 17th-century engineering wonder located near Bibi ka Maqbara. Powered by an underground water channel stretching over 8 km, it once served to grind grains for Sufi saints and pilgrims. The complex also houses a tranquil pond, mosque, and garden shaded by ancient trees. The sound of cascading water creates an atmosphere of calm reflection. Panchakki symbolizes the fusion of faith and ingenuity that defined Mughal Aurangabad. Its serene surroundings invite travelers to pause and admire a perfect blend of spirituality and science."
  },
  {
    "title": "Aurangabad Caves",
    "description": "The Aurangabad Caves, carved between the 6th and 8th centuries, remain one of the city’s hidden treasures. These 12 Buddhist caves feature chaityas (prayer halls) and viharas (monastic cells) adorned with carvings depicting Buddha, Bodhisattvas, and celestial maidens. Located atop a hill overlooking Bibi ka Maqbara, the caves offer stunning panoramic views of the city and surrounding plains. The serene setting, combined with centuries-old art, makes them an ideal destination for meditation and photography. The Aurangabad Caves beautifully bridge Sambhajinagar’s artistic past and its modern identity."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Siddharth Garden and Zoo is Sambhajinagar’s most vibrant recreational spot, spread over 17 acres near the railway station. Lush lawns, musical fountains, and a variety of flora make it a favorite weekend destination for families. The zoo houses tigers, leopards, peacocks, and exotic birds that delight visitors of all ages. During evenings, the garden comes alive with lights and joyful crowds. It’s a perfect place to unwind after exploring the historical wonders of the city. Siddharth Garden adds color, life, and fresh air to the cultural landscape of Sambhajinagar."
  },
  {
    "title": "Bani Begum Garden",
    "description": "Bani Begum Garden, named after the wife of Aurangzeb’s son Azam Shah, is a beautiful blend of Mughal and Persian landscape design. Located near Khuldabad, it features arched pavilions, fountains, and pathways lined with fragrant flowers. Once a royal pleasure garden, it now offers visitors a peaceful retreat away from the city noise. The marble tomb at its center adds grace and serenity to the view. During spring, the blooming bougainvilleas and birdsong create a poetic ambience. Bani Begum Garden reflects the romantic and aesthetic legacy of Sambhajinagar’s royal past."
  },
  {
    "title": "Gautala Autramghat Sanctuary",
    "description": "Located about 70 km from Sambhajinagar, Gautala Autramghat Wildlife Sanctuary is a lush expanse of deciduous forest and rolling hills. Spread across 260 square kilometers, it houses leopards, barking deer, sloth bears, and over 200 species of birds. Seasonal waterfalls and rocky valleys make it a picturesque spot for nature lovers. Trekkers and photographers find it ideal for adventure and solitude. The sanctuary’s tranquil beauty and rich biodiversity offer a refreshing escape from urban life. Gautala Autramghat is Sambhajinagar’s green heartbeat — a place where nature whispers its oldest songs."
  }
],



"services": [
  {
    "name": "Pune to Sambhajinagar Cabs",
    "description": "Book comfortable Pune to Sambhajinagar cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Sambhajinagar Taxi Service",
    "description": "Hire a Pune to Sambhajinagar taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Sambhajinagar Car Hire",
    "description": "Rent a car from Pune to Sambhajinagar for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Sambhajinagar",
    "description": "Travel comfortably with AC cab service from Pune to Sambhajinagar. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Sambhajinagar",
    "description": "Affordable non-AC cab service from Pune to Sambhajinagar for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Sambhajinagar",
    "description": "Book spacious and comfortable Innova cabs from Pune to Sambhajinagar. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Sambhajinagar",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Sambhajinagar. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Sambhajinagar",
    "description": "Travel in style with luxury cab services from Pune to Sambhajinagar. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Sambhajinagar",
    "description": "Get pocket-friendly Pune to Sambhajinagar cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Sambhajinagar Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Sambhajinagar ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Sambhajinagar One Way Cab",
    "description": "Book one-way cabs from Pune to Sambhajinagar at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Sambhajinagar without return plans."
  },
  {
    "name": "Pune to Sambhajinagar Drop Cab",
    "description": "One-way drop cab service from Pune to Sambhajinagar with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Sambhajinagar",
    "description": "Premium corporate cab hire from Pune to Sambhajinagar with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Sambhajinagar",
    "description": "Elegant wedding cab service from Pune to Sambhajinagar with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Sambhajinagar",
    "description": "Book your Pune to Sambhajinagar cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Sambhajinagar Cabs", "Pune to Sambhajinagar Taxi Service"],
  ["Pune to Sambhajinagar Car Hire", "AC Cab Pune to Sambhajinagar"],
  ["Non AC Cab Pune to Sambhajinagar", "Innova Cab Pune to Sambhajinagar"],
  ["Ertiga Cab Pune to Sambhajinagar", "Luxury Cab Pune to Sambhajinagar"],
  ["Affordable Cab Pune to Sambhajinagar", "Pune to Sambhajinagar Outstation Cab"],
  ["Pune to Sambhajinagar One Way Cab", "Pune to Sambhajinagar Drop Cab"],
  ["Online Cab Booking Pune to Sambhajinagar", "Corporate Cab Pune to Sambhajinagar"],
  ["Wedding Cab Pune to Sambhajinagar", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Sambhajinagar Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and reliable cab services from Pune to Sambhajinagar (Aurangabad) — ideal for family trips, historical site visits, business travel, and weekend getaways."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy affordable and transparent fares for Pune to Sambhajinagar cabs — no hidden charges, no surge pricing, and complete value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and premium cars according to your comfort, group size, and budget for the Pune–Sambhajinagar route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are well-acquainted with the Pune to Sambhajinagar route, ensuring a safe, smooth, and on-time journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups from anywhere in Pune — airport, railway station, home, or office — and drop-offs at your chosen destination in Sambhajinagar."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs provides clean, sanitized, and regularly serviced vehicles to ensure a pleasant and worry-free travel experience every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated customer support team is available round the clock to help you with booking, fare details, or travel assistance for your Pune to Sambhajinagar trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Sambhajinagar cab easily through call, WhatsApp, or our website — get instant confirmation and prompt service."
  }
]

























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Sambhajinagar cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Sambhajinagar cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Sambhajinagar cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Sambhajinagar cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Sambhajinagar?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Sambhajinagar routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Sambhajinagar route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Sambhajinagar?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Sambhajinagar for popular attractions like Bibi Ka Maqbara, Ellora Caves, Daulatabad Fort, and Panchakki.',
  },
  {
    question: 'Is the Pune to Sambhajinagar cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Sambhajinagar cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Sambhajinagar cab fares?',
    answer: 'Our Pune to Sambhajinagar cab fares start from ₹2,500 for sedans and ₹3,000–₹3,800 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Sambhajinagar cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Sambhajinagar cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Sambhajinagar cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Sambhajinagar trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Jadhav',
    feedback: 'Had a great experience traveling from Pune to Sambhajinagar with Sai Trupti Cabs. The cab was clean, comfortable, and the driver was polite and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Patil',
    feedback: 'Sai Trupti Cabs made our Pune to Sambhajinagar trip hassle-free. Excellent service, smooth ride, and very professional staff!',
    rating: 5,
  },
];
























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Sambhajinagar (Aurangabad) Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-sambhajinagar-cab.jpg",
  "description": "Sai Trupti Cabs provides Pune to Sambhajinagar (Aurangabad) cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book affordable outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Sambhajinagar Aurangabad"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7680"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-sambhajinagar-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};





  return (
    <div>
<Helmet>
  <title>Pune to Sambhajinagar (Aurangabad) Cab Service | One Way Taxi ₹3499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Sambhajinagar (Aurangabad) cab at best price ₹3499 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, affordable and 24x7 cab service." 
  />

  <meta 
    name="keywords" 
    content="pune to sambhajinagar cab, pune to aurangabad cab, pune to aurangabad taxi, pune to sambhajinagar taxi, pune to aurangabad cab service, pune to sambhajinagar one way cab, pune to aurangabad taxi fare, pune to aurangabad innova crysta, pune to aurangabad ertiga cab, cheap pune to aurangabad cab, best cab service pune to aurangabad, pune to aurangabad drop taxi, pune to aurangabad round trip cab, outstation cab pune to aurangabad, pune to aurangabad online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosambhajinagarcabs;